"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderBySum = exports.CompatibleOrderBySumConfig = void 0;
const lodash_1 = __importDefault(require("lodash"));
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./utils");
const getComparableValue = (field) => (loanTape) => {
    const value = (0, utils_1.getFieldValue)({ loanTape, field });
    return lodash_1.default.isNumber(value) ? value : lodash_1.default.toString(value);
};
class CompatibleOrderBySumConfig {
    constructor(config) {
        this.config = config;
        this.operation = 'orderBySum';
        // Private instance properties allow typescript to ensure that an instance of
        // this class is being used.
        this.isCompatible = true;
        this.ensureCompatibility = (loanTape) => {
            const { type, groupBy } = this.config;
            const invalidRecord = lodash_1.default.find(loanTape, (record) => {
                const value = (0, utils_1.getFieldValue)({ loanTape: record, field: groupBy });
                return !lodash_1.default.isNil(value) && typeof value !== type;
            });
            (0, common_1.finleyAssert)(!invalidRecord, (0, utils_1.getInvalidFieldTypeMessage)({ invalidRecord, field: groupBy, type }));
            (0, common_1.finleyAssert)(this.isCompatible, 'Config must be compatible with loanTape');
        };
        this.config = config;
    }
}
exports.CompatibleOrderBySumConfig = CompatibleOrderBySumConfig;
CompatibleOrderBySumConfig.create = (config, loanTape) => {
    const obj = new CompatibleOrderBySumConfig(config);
    obj.ensureCompatibility(loanTape);
    return obj;
};
/*
 * groups loanTapes by groupBy and orders them by
 * the sum of their borrowing base amount. Then selects
 * the loan tapes in the first N groups
 *
 * example config:
 * {
 *    operation: 'orderBySum',
 *    field: 'borrowingBaseAmount',
 *    groupBy: 'industry',
 *    count: 1,
 *    offset: 1
 * }
 *
 */
const orderBySum = ({ config: { groupBy, field, count, offset }, }) => (loanTapeRecords) => {
    return (0, remeda_1.pipe)(loanTapeRecords, (0, remeda_1.filter)((0, utils_1.propertyIsNotNil)(groupBy)), (0, remeda_1.groupBy)(getComparableValue(groupBy)), remeda_1.values, (0, remeda_1.sortBy)([
        (receivables) => lodash_1.default.sumBy(receivables, (receivable) => {
            return (0, utils_1.getFieldValue)({ loanTape: receivable, field });
        }),
        'desc',
    ]), (0, remeda_1.drop)(offset || 0), (0, remeda_1.take)(count), (0, remeda_1.flatten)());
};
exports.orderBySum = orderBySum;
//# sourceMappingURL=orderBySum.js.map